export function randomThreeDigitNumber() {
  return Math.floor(Math.random() * 900) + 100; // Gives a number between 100 and 999
}

export function convertToEnglishChars(filename) {
  // Extract the file extension and name part
  const fileExtension = filename.slice(
    ((filename.lastIndexOf('.') - 1) >>> 0) + 2,
  );
  let nameWithoutExtension = filename.substring(0, filename.lastIndexOf('.'));

  // Replace non-English letters and numbers with a random English letter
  nameWithoutExtension = nameWithoutExtension.replace(
    /[^a-zA-Z0-9_-]/g,
    '_',
  );

  // If the resulting filename is empty, default to "file" followed by a random number
  if (!nameWithoutExtension) {
    nameWithoutExtension = `file${randomThreeDigitNumber()}`;
  }

  return `${nameWithoutExtension}.${fileExtension}`;
}

// Utility to convert snake_case to camelCase
export function snakeToCamel(str) {
  return str.replace(/_([a-z])/g, g => g[1].toUpperCase());
}

export function keysToCamel(obj) {
  if (Array.isArray(obj)) {
    return obj.map(v => keysToCamel(v));
  } else if (obj !== null && obj.constructor === Object) {
    return Object.keys(obj).reduce((acc, key) => {
      acc[snakeToCamel(key)] = keysToCamel(obj[key]);
      return acc;
    }, {});
  }
  return obj;
}
